(function() {
'use strict';

angular
.module('TR')
.service('hotelResolver', hotelResolver);

function hotelResolver(recentHotels,
        hotelService,
        $route,
        tripService,
        basketStore) {
    const service = {
        resolve
    };

    function resolve(includeRooms) {
        const tripId = $route.current.params.tripId;
        const estabId = parseInt($route.current.params.estabId);

        if (TRPCONFIG.Domain2.GetReviewedHotelsAPI) {
            recentHotels.set(estabId);
        }

        return tripService.restoreSearchUnit(tripId).then(function(trip) {
            if (trip && trip.HotelsRequest) {
                const promise = hotelService.getHotel(includeRooms ? trip.HotelsRequest.AvailabilitySearchId : null, estabId, tripId);

                const calculateTotalCost = (hotelInfo, costAggregator) => {
                    hotelInfo.Rooms.forEach(rr => {
                        rr.Availability.forEach(costAggregator);
                        rr.selected = rr.Availability[0].Id;
                    });
                    return hotelInfo;
                };

                if (TRPCONFIG.Domain.PackagePrice && trip.FlightsRequest && trip.FlightsRequest.SelectedFlight) {
                    return promise.then(function(hotelInfo) {
                        return basketStore.flightCost(trip.BasketId).then(function(flightCost) {
                            return calculateTotalCost(hotelInfo, a => a.TotalCost = a.Cost + flightCost / hotelInfo.Rooms.length);
                        });
                    });
                }

                return promise.then(function(hotelInfo) {
                    return calculateTotalCost(hotelInfo, a => a.TotalCost = a.Cost);
                });
            }
        });
    }

    return service;
}
})();
